"use client";

import React, { useState, useEffect } from "react";
//import Link from 'next/link';
import { ArrowLeft } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
import CurrencyDropdownTransparentBlack from "../../components/CurrencyDropdownTransparentBlack";
import SelectTimeframe from "../../components/SelectTimeframe";
import SelectLanguage from "../../components/SelectLanguage";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import { useAuth } from "../../context/AuthContext";
import Toaster from "../../components/ui/toaster";

export default function SettingsPreferences() {
  const { settings } = useAuth();
  //const lang = settings.data.data.preferences.language;
  //const [localCurrency, setlocalCurrency] = useState(settings.data.data.preferences.localCurrency);
  //const [timeFrame, setTimeFrame] = useState(settings.preferences.performancePeriod);
  const [language, setLanguage] = useState("");
  const navigate = useNavigate();

  function getLanguage(lang) {
    setLanguage(lang);
  }
  useEffect(() => {}, []);

  return (
    <>
      <Header />
      <Toaster />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <div
            className="mr-5 border-rounded rounded-full p-1 border"
            onClick={() => {
              navigate("/settings/index");
            }}
          >
            <ArrowLeft size={14} />
          </div>
          <p className="text-sm font-medium">Settings / Preferences</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
                  Preferences
                </CardTitle>
              </CardHeader>

              <CardContent className="px-6 pb-4 space-y-4">
                <div className="flex justify-between items-center border-solid border-[1px] rounded-[20px] border-gray-200 py-5 px-4">
                  <div>
                    <p className="font-semibold text-text-primary text-[16px] ">
                      Local currency
                    </p>
                    <p className="font-semibold text-text-secondary text-[14px] mt-1">
                      {settings?.preferences?.localCurrency || "ZAR"}
                    </p>
                  </div>
                  <CurrencyDropdownTransparentBlack
                    localCurrency={
                      settings?.preferences?.localCurrency || "ZAR"
                    }
                  />
                </div>

                <div className="flex justify-between items-center border-solid border-[1px] rounded-[20px] border-gray-200 py-5 px-4">
                  <div>
                    <p className="font-semibold text-text-primary text-[16px]">
                      Performance timeframe
                    </p>
                    <p className="font-semibold text-text-secondary text-[14px] mt-1">
                      {settings?.preferences?.performancePeriod
                        .charAt(0)
                        .toUpperCase() +
                        settings?.preferences?.performancePeriod.slice(1)}
                    </p>
                  </div>
                  <SelectTimeframe
                    timeFrame={
                      settings?.preferences?.performancePeriod || "Monthly"
                    }
                    type={"prefer"}
                  />
                </div>

                <div className="flex justify-between items-center  border-solid border-[1px] rounded-[20px] border-gray-200 py-5 px-4">
                  <div>
                    <p className="font-semibold text-text-primary text-[16px]">
                      Language
                    </p>
                    <p className="font-semibold text-text-secondary text-[14px] mt-1">
                      {language}
                    </p>
                  </div>
                  <SelectLanguage getLanguage={getLanguage} />
                </div>
              </CardContent>

              <Separator />

              <div className="py-4 text-center text-sm text-gray-500">
                Need to update your preferences?{" "}
                <a
                  href="/support/index"
                  className="text-rose-600 font-bold hover:underline cursor-pointer"
                >
                  Contact us
                </a>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
